/**
 * Client API pour les préférences utilisateur
 */
import { HttpClient } from '@sphere/shared/data-access/http';
import type {
  UserPreference,
  SetPreferenceDto,
  SetPreferencesBulkDto,
} from '@sphere/user/domain';

const BASE_PATH = '/preferences';

export const preferencesClient = {
  /**
   * Récupère toutes les préférences de l'utilisateur
   */
  async getAll(): Promise<UserPreference[]> {
    const { data } = await HttpClient.get<{
      preferences: Record<string, unknown>;
      _raw: UserPreference[];
    }>(BASE_PATH);
    // L'API retourne { preferences: {...}, _raw: [...] }
    return data._raw ?? [];
  },

  /**
   * Récupère une préférence par clé
   */
  async getByKey(key: string): Promise<UserPreference> {
    const { data } = await HttpClient.get<UserPreference>(
      `${BASE_PATH}/${key}`
    );
    return data;
  },

  /**
   * Définit ou met à jour une préférence
   */
  async set(dto: SetPreferenceDto): Promise<UserPreference> {
    const { data } = await HttpClient.post<UserPreference>(BASE_PATH, dto);
    return data;
  },

  /**
   * Définit plusieurs préférences en masse
   */
  async setBulk(preferences: SetPreferenceDto[]): Promise<UserPreference[]> {
    const { data } = await HttpClient.post<UserPreference[]>(
      `${BASE_PATH}/bulk`,
      {
        preferences,
      } as SetPreferencesBulkDto
    );
    return data;
  },

  /**
   * Supprime une préférence
   */
  async delete(key: string): Promise<void> {
    await HttpClient.delete(`${BASE_PATH}/${key}`);
  },

  /**
   * Supprime toutes les préférences
   */
  async deleteAll(): Promise<{ count: number }> {
    const { data } = await HttpClient.delete<{ count: number }>(BASE_PATH);
    return data;
  },
};
